import React from 'react';
import Layout from './layout/Layout';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {Login} from "./ui/auth/Login";
import { ProtectedRoute } from "./routes/ProtectedRoute";

function App() {
  return (
      <BrowserRouter>
          <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                  path="/*"
                  element={
                      <ProtectedRoute>
                          <Layout />
                      </ProtectedRoute>
                  }
              />
          </Routes>
      </BrowserRouter>
  );
}

export default App;
